'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$JWToken$() {
  this.c8R = null;
  this.c8S = false;
}
export { $c_Lpresto_types$JWToken$ as $c_Lpresto_types$JWToken$ };
$p = $c_Lpresto_types$JWToken$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$JWToken$;
/** @constructor */
function $h_Lpresto_types$JWToken$() {
}
export { $h_Lpresto_types$JWToken$ as $h_Lpresto_types$JWToken$ };
$h_Lpresto_types$JWToken$.prototype = $p;
$p.cJa = (function() {
  if ((!this.c8S)) {
    this.c8R = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c8S = true;
  }
  return this.c8R;
});
var $d_Lpresto_types$JWToken$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$JWToken$, "presto.types$JWToken$", ({
  a0H: 1,
  D: 1
}));
export { $d_Lpresto_types$JWToken$ as $d_Lpresto_types$JWToken$ };
var $n_Lpresto_types$JWToken$;
function $m_Lpresto_types$JWToken$() {
  if ((!$n_Lpresto_types$JWToken$)) {
    $n_Lpresto_types$JWToken$ = new $c_Lpresto_types$JWToken$();
  }
  return $n_Lpresto_types$JWToken$;
}
export { $m_Lpresto_types$JWToken$ as $m_Lpresto_types$JWToken$ };
//# sourceMappingURL=presto.types$-J-W-Token$.js.map
